import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import produce from 'immer';
import set from 'lodash/set';
import * as api from 'app/api';

const CHANGE_VALUE = 'ohMyCall/CHANGE_VALUE';
export const changeValue = createAction(CHANGE_VALUE);

const GET_PROLOGUE = 'ohMyCall/GET_PROLOGUE';
export const getPrologue = createAction(GET_PROLOGUE, api.getPrologue);

const GET_CUSTOMER_PHONE = 'ohMyCall/GET_CUSTOMER_PHONE';
export const getCustomerPhone = createAction(GET_CUSTOMER_PHONE, api.getCustomerPhone);

const GET_CUSTOMER_ACQUISITION = 'ohMyCall/GET_CUSTOMER_ACQUISITION';
export const getCustomerAcquisition = createAction(GET_CUSTOMER_ACQUISITION, api.getCustomerAcquisition);

const GET_DEFAULT_ACQUISITION = 'ohMyCall/GET_DEFAULT_ACQUISITION';
export const getDefaultAcquisition = createAction(GET_DEFAULT_ACQUISITION, api.getDefaultAcquisition);

const GET_DOCUMENT = 'ohMyCall/GET_DOCUMENT';
export const getDocument = createAction(GET_DOCUMENT, api.getMycallDocument);

const GET_NAME_CARD = 'ohMyCall/GET_NAME_CARD';
export const getNameCard = createAction(GET_NAME_CARD, api.getNameCard);

const GET_FINANCE = 'ohMyCall/GET_FINANCE';
export const getFinance = createAction(GET_FINANCE, api.getFinance);

const GET_MESSAGE_ACQUISITION = 'ohMyCall/GET_MESSAGE_ACQUISITION';
export const getMessageAcquisition = createAction(GET_MESSAGE_ACQUISITION, api.getMessageAcquisition);

const initialState = {
	prologueInfo: {},
	customerPhone: {},
	currentAcquisition: {
		inspectionInsuranceCost: 0,
		regionSellingCost: 0,
		registrarCost: 0,
		etcCost: 0,
		purpose: '비영업용',
		welfare: '',
	},
	nameCard: {},
	documentInfo: {},
	previewAcquisition: {},
};

export default handleActions(
	{
		[CHANGE_VALUE]: (state, action) =>
			produce(state, (draft) => {
				const { schema, name, value } = action.payload;
				set(draft, [...schema, name], value);
			}),
		...pender({
			type: GET_PROLOGUE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'prologueInfo', data);
				}),
		}),
		...pender({
			type: GET_CUSTOMER_PHONE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					set(draft, 'customerPhone', data);
				}),
		}),
		...pender({
			type: GET_CUSTOMER_ACQUISITION,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					set(draft, 'currentAcquisition', data);
				}),
		}),
		...pender({
			type: GET_DEFAULT_ACQUISITION,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					set(draft, 'currentAcquisition', data);
				}),
		}),
		...pender({
			type: GET_DOCUMENT,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					set(draft, 'documentInfo', data);
				}),
		}),
		...pender({
			type: GET_NAME_CARD,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					set(draft, 'nameCard', data);
					if (data.comment) set(draft, 'inputCardText', data.comment);
				}),
		}),
		...pender({
			type: GET_FINANCE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					set(draft, 'finance', data);
				}),
		}),
		...pender({
			type: GET_MESSAGE_ACQUISITION,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					set(draft, 'previewAcquisition', data);
				}),
		}),
	},
	initialState,
);
